export function AuditLogService($http, apexApiUrl) {
    'ngInject';
    return {
        retrieveEmployeeTimekeepingAuditLogs: retrieveEmployeeTimekeepingAuditLogs,
        retrieveEmployeeTimekeepingAuditLog: retrieveEmployeeTimekeepingAuditLog,
        retrieveTimeEntryModificationsAuditLogs: retrieveTimeEntryModificationsAuditLogs,
        retrieveTimeEntryModificationsAuditLog: retrieveTimeEntryModificationsAuditLog,
        retrieveAcknowledgedModifiedTimeEntryAuditLogs: retrieveAcknowledgedModifiedTimeEntryAuditLogs,
        retrieveAcknowledgedModifiedTimeEntryAuditLog: retrieveAcknowledgedModifiedTimeEntryAuditLog,
        retrieveEmployeeTimekeepingAuditLogsPage: retrieveEmployeeTimekeepingAuditLogsPage,
        retrieveTimeEntryModificationsAuditLogsPage: retrieveTimeEntryModificationsAuditLogsPage
    };

    /**
     * Retrieve all timekeeping audit logs.
     */
    function retrieveEmployeeTimekeepingAuditLogs(query) {
        return $http({
            method: "GET",
            url: apexApiUrl + "audit-logs/timekeeping",
            params: query || {},
            headers: {
                Accept: "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Retrieve page of timekeeping audit logs matches the given query.
     */
    function retrieveEmployeeTimekeepingAuditLogsPage(pageIndex, query) {
        return $http({
            method: "GET",
            url: apexApiUrl + "audit-logs/timekeeping/page/" + pageIndex || 0,
            params: query || {},
            headers: {
                Accept: "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Retrieve timekeeping audit logs for the given employee.
     */
    function retrieveEmployeeTimekeepingAuditLog(employeeID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "audit-logs/timekeeping/employee/" + employeeID,
            headers: {
                Accept: "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveTimeEntryModificationsAuditLogs() {
        return $http({
            method: "GET",
            url: apexApiUrl + "audit-logs/time-entry-modification",
            headers: {
                Accept: "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveTimeEntryModificationsAuditLogsPage(pageIndex, query) {
        return $http({
            method: "GET",
            url: apexApiUrl + "audit-logs/time-entry-modification/page/" + pageIndex || 0,
            params: query || {},
            headers: {
                Accept: "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveTimeEntryModificationsAuditLog(employeeID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "audit-logs/time-entry-modification/modification-employee/" + employeeID,
            headers: {
                Accept: "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveAcknowledgedModifiedTimeEntryAuditLogs() {
        return $http({
            method: "GET",
            url: apexApiUrl + "audit-logs/acknowledged-modified-time-entry",
            headers: {
                Accept: "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveAcknowledgedModifiedTimeEntryAuditLog(acknowledgedEmployeeID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "audit-logs/acknowledged-modified-time-entry/acknowledged-employee/" + acknowledgedEmployeeID,
            headers: {
                Accept: "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }
}
